export var ProjectMemberMutationTypes;
(function (ProjectMemberMutationTypes) {
    ProjectMemberMutationTypes["INIT_STATE"] = "INIT_STATE";
    ProjectMemberMutationTypes["FETCH_MEMBERS"] = "FETCH_MEMBERS";
    ProjectMemberMutationTypes["FETCH_INVITED_USERS"] = "FETCH_INVITED_USERS";
    ProjectMemberMutationTypes["DELETE_PROJECT_MEMBER"] = "DELETE_PROJECT_MEMBER";
    ProjectMemberMutationTypes["CANCEL_INVITATION"] = "CANCEL_INVITATION";
    ProjectMemberMutationTypes["CHANGE_USER_TYPE"] = "CHANGE_USER_TYPE";
    ProjectMemberMutationTypes["UPDATE_PROJECT_USER_PRICE"] = "UPDATE_PROJECT_USER_PRICE";
})(ProjectMemberMutationTypes || (ProjectMemberMutationTypes = {}));
